import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, CheckboxModule, DropdownModule, IconModule, InputtextModule, MultiselectModule, SelectButtonModule, SideMenuModule, SplitButtonModule, TableModule } from '@atsystems/ui';
import { DatepickerModule } from '@atsystems/ui';
import { PaginatorModule } from '@atsystems/ui';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  exports: [
    ButtonModule,
    CheckboxModule,
    InputtextModule,
    DropdownModule,
    MultiselectModule,
    SideMenuModule,
    IconModule,
    SelectButtonModule,
    SplitButtonModule,
    TableModule,
    DatepickerModule,
    PaginatorModule
  ]
})
export class UiModule { }
